"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticEmailStatus = void 0;
var AutomaticEmailStatus;
(function (AutomaticEmailStatus) {
    AutomaticEmailStatus[AutomaticEmailStatus["Scheduled"] = 0] = "Scheduled";
    AutomaticEmailStatus[AutomaticEmailStatus["Requested"] = 1] = "Requested";
    AutomaticEmailStatus[AutomaticEmailStatus["Accepted"] = 2] = "Accepted";
    AutomaticEmailStatus[AutomaticEmailStatus["Rejected"] = 3] = "Rejected";
    AutomaticEmailStatus[AutomaticEmailStatus["Delivered"] = 4] = "Delivered";
    AutomaticEmailStatus[AutomaticEmailStatus["Failed"] = 5] = "Failed";
    AutomaticEmailStatus[AutomaticEmailStatus["Opened"] = 6] = "Opened";
    AutomaticEmailStatus[AutomaticEmailStatus["Clicked"] = 7] = "Clicked";
    AutomaticEmailStatus[AutomaticEmailStatus["Unsubscribed"] = 8] = "Unsubscribed";
    AutomaticEmailStatus[AutomaticEmailStatus["Complained"] = 9] = "Complained";
    AutomaticEmailStatus[AutomaticEmailStatus["Stored"] = 10] = "Stored";
    AutomaticEmailStatus[AutomaticEmailStatus["Mixed"] = 11] = "Mixed";
})(AutomaticEmailStatus || (exports.AutomaticEmailStatus = AutomaticEmailStatus = {}));
//# sourceMappingURL=AutomaticEmailStatus.js.map